<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <span class="m-quick-sidebar__close mt-2" @click="closeThis()">
        <i class="fal fa-times-circle fa-lg"></i>
      </span>
      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
      >
        <li class="nav-item m-tabs__item">
          <a
            class="nav-link m-tabs__link active"
            data-toggle="tab"
            href="#save_plan"
            role="tab"
          >
            <h5><span class="far fa-pen-nib"></span> Plano</h5>
          </a>
        </li>
        <li class="nav-item m-tabs__item" v-if="planId > 0">
          <a
            class="nav-link m-tabs__link"
            data-toggle="tab"
            href="#save_services"
            role="tab"
          >
            <h5><span class="far fa-usd-circle"></span> Cobrança</h5>
          </a>
        </li>
        <li class="nav-item m-tabs__item" v-if="planId > 0">
          <a
            class="nav-link m-tabs__link"
            data-toggle="tab"
            href="#contract_history"
            role="tab"
          >
            <h5><span class="far fa-history"></span> Histórico</h5>
          </a>
        </li>
      </ul>
      <div class="tab-content">
        <div class="tab-pane active" id="save_plan" role="tabpanel">
          <PlanSaveForm
            :plan="data"
            @savedPlan="savedPlan"
            :changeReason="change_reason"
          />
        </div>
        <div class="tab-pane" id="save_services" role="tabpanel">
          <PlanServices
            :changeReason="change_reason"
            @changedReason="changedReason"
          />
        </div>
        <div class="tab-pane" id="contract_history" role="tabpanel">
          <PlanHistory />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PlanSaveForm from '@/components/plans/PlanSaveForm';
import PlanServices from '@/components/plans/PlanService';
import PlanHistory from '@/components/plans/PlanHistory';
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'PlanModal',
  data() {
    return {
      data: {},
      change_reason: null,
    };
  },
  components: {
    PlanSaveForm,
    PlanServices,
    PlanHistory,
  },
  methods: {
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showPlanSave = null;
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/plans/data/${this.planId}`;
      axios(url).then((res) => {
        if (res.data) {
          res.data.change_reason = null;
          this.data = res.data;
        }
      });
    },
    savedPlan(data) {
      this.change_reason = data.change_reason;
      this.data = data;
    },
    changedReason(changed_reason) {
      this.change_reason = changed_reason;
    },
  },
  computed: {
    planId() {
      return this.$store.state.showPlanSave;
    },
  },
  beforeMount() {
    this.getDatas();
  },
};
</script>
<style>
.m-quick-sidebar-overlay {
  background: rgba(0, 0, 0, 0.3);
}

@media (min-width: 1201px) {
  #m_quick_sidebar {
    width: 50% !important;
  }
}

@media (min-width: 601px) and (max-width: 1200px) {
  #m_quick_sidebar {
    width: 60% !important;
  }
}

@media (max-width: 600px) {
  #m_quick_sidebar {
    width: 100% !important;
  }
}
</style>
